import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import useFitCount from 'hooks/useFitCount';
import styles from 'styles/modules/Raws.module.scss';

const TAG_LIMIT = 5;

const RawTags = ({ tags }) => {
    const [expanded, setExpanded] = useState(false);
    const wrapperRef = useRef(null);
    const listRef = useRef(null);
    const buttonRef = useRef(null);
    // Overflow chips are taken out of the row but keep their size, so every
    // candidate can be measured whatever is showing.
    const visible = useFitCount({
        rowRef: wrapperRef,
        buttonRef,
        measure: () =>
            [...listRef.current.children].map(
                ({ firstElementChild: link }) =>
                    link.scrollWidth + link.offsetWidth - link.clientWidth
            ),
        total: tags.length,
        max: TAG_LIMIT,
        key: tags.map((tag) => tag.id).join(),
        gap: 6,
        enabled: !expanded,
    });
    const hidden = tags.length - visible;

    useEffect(() => {
        if (expanded) listRef.current.querySelectorAll('a')[visible]?.focus();
    }, [expanded]);

    return (
        <div
            ref={wrapperRef}
            className={[styles.tags, expanded ? styles.tagsExpanded : '']
                .join(' ')
                .trim()}
            data-nosnippet
        >
            <ul ref={listRef}>
                {tags.map((tag, index) => (
                    <li
                        key={tag.id}
                        className={
                            !expanded && index >= visible
                                ? styles.tagOverflow
                                : undefined
                        }
                    >
                        <Link href={`/raws?tag=${tag.id}`}>
                            <a>{tag.name}</a>
                        </Link>
                    </li>
                ))}
            </ul>
            {hidden > 0 && (
                <button
                    ref={buttonRef}
                    type="button"
                    aria-expanded={expanded}
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? 'Show less' : `+${hidden} more`}
                </button>
            )}
        </div>
    );
};

export default RawTags;
